import { Underlying } from 'models/underlying';

export function toUnderlyingArray(value?: unknown): Underlying[] | undefined {
  if (!value || typeof value !== 'string') {
    return undefined;
  }
  return value
    .split(',')
    .map(v => v.trim())
    .filter(Boolean)
    .map(
      id =>
        ({
          id,
        }) as Underlying,
    );
}
